<div class="thread-selector" [class.thread-selector--sidebar]="variant === 'sidebar'">

  <!-- Recientes + filtro de tipo (app#690, estilo Claude): un único listado;
       «Todo» mezcla chats y ejecuciones de regla, con icono por tipo. -->
  <div class="thread-tools">
    <span class="thread-tools__label">{{ 'agent.recents' | translate }}</span>
    <!-- ↗ historial completo («Ver todas» vive aquí, como en Claude) -->
    <button type="button" class="thread-tools__filter"
      (click)="goToHistory()"
      [title]="'agent.viewAll' | translate"
      [attr.aria-label]="'agent.viewAll' | translate">
      <i class="pi pi-arrow-up-right"></i>
    </button>
    <button type="button" class="thread-tools__filter"
      [class.is-filtered]="typeFilter() !== 'all'"
      (click)="toggleFilterMenu()"
      [title]="'agent.filterType' | translate"
      [attr.aria-label]="'agent.filterType' | translate"
      [attr.aria-expanded]="filterMenuOpen()">
      <i class="pi pi-sliders-h"></i>
    </button>

    <div class="type-filter-backdrop" *ngIf="filterMenuOpen()" (click)="filterMenuOpen.set(false)"></div>
    <div class="type-filter-menu" *ngIf="filterMenuOpen()" role="menu">
      <span class="type-filter-menu__title">{{ 'agent.filterType' | translate }}</span>
      <button type="button" role="menuitemradio" class="type-filter-menu__option"
        *ngFor="let opt of filterOptions"
        [class.selected]="typeFilter() === opt.value"
        [attr.aria-checked]="typeFilter() === opt.value"
        (click)="setTypeFilter(opt.value)">
        <i class="pi" [ngClass]="opt.icon"></i>
        <span>{{ opt.labelKey | translate }}</span>
        <i class="pi pi-check type-filter-menu__check" *ngIf="typeFilter() === opt.value"></i>
      </button>
    </div>
  </div>

  <!-- Nueva conversación — SOLO en el diálogo (móvil). En el rail la acción
       vive como [+] dentro de la propia fila del Agente. -->
  <button pButton
    type="button"
    class="new-thread-btn"
    *ngIf="variant === 'dialog'"
    (click)="createNewThread()"
    [title]="'agent.newConversation' | translate">
    <i class="pi pi-plus"></i>
    {{ 'agent.newConversation' | translate }}
  </button>

  <p-iconfield iconPosition="right" *ngIf="showSearch()">
    <input
      type="text"
      pInputText
      [pAutoFocus]="variant === 'dialog'"
      [placeholder]="'agent.searchConversations' | translate"
      [ngModel]="threadSearchQuery()"
      (ngModelChange)="threadSearchQuery.set($event)" />
    <p-inputicon class="pi pi-search" />
  </p-iconfield>

  <!-- Vaciar el listado — SOLO en el diálogo (móvil). En el rail no está
       (como en Claude, donde el borrado masivo vive en Ajustes, no en la
       sidebar). Acción destructiva → texto plano hasta que se arma, con
       confirmación inline. Actúa sobre lo LISTADO: con un filtro activo, el
       contador ya lo dice. -->
  <div class="thread-bulk" *ngIf="variant === 'dialog' && filteredThreads().length">
    <button type="button" class="bulk-delete-trigger"
      *ngIf="!confirmingDeleteAll"
      (click)="requestDeleteAllThreads()">
      <i class="pi pi-trash"></i>
      {{ 'agent.deleteAllConversations' | translate: { count: filteredThreads().length } }}
    </button>

    <div class="bulk-delete-confirm" *ngIf="confirmingDeleteAll">
      <p class="bulk-delete-warning">
        {{ 'agent.deleteAllWarning' | translate: { count: filteredThreads().length } }}
        <span *ngIf="awaitingDecisionInSelection() as pending">
          {{ 'agent.deleteAllPendingWarning' | translate: { count: pending } }}
        </span>
      </p>
      <div class="bulk-delete-actions">
        <button pButton type="button" class="confirm-delete-btn"
          [disabled]="isDeletingAll"
          (click)="confirmDeleteAllThreads()">
          <i class="pi" [ngClass]="isDeletingAll ? 'pi-spinner pi-spin' : 'pi-trash'"></i>
          {{ 'common.delete' | translate }}
        </button>
        <button pButton type="button" class="cancel-delete-btn"
          [disabled]="isDeletingAll"
          (click)="cancelDeleteAllThreads()">
          {{ 'common.cancel' | translate }}
        </button>
      </div>
    </div>

    <p class="bulk-delete-failed" *ngIf="deleteAllFailed">
      {{ 'agent.deleteAllFailed' | translate: { count: deleteAllFailed } }}
    </p>
  </div>

  <div class="thread-list" role="list">
    <div *ngFor="let thread of filteredThreads(); trackBy: trackByThread"
      role="listitem"
      class="thread-item"
      tabindex="0"
      [class.active]="isActiveThread(thread)"
      [class.streaming]="isStreamingThread(thread)"
      [class.awaiting]="isAwaitingDecisionThread(thread)"
      [class.editing]="editingThreadId === thread.thread_id"
      [class.confirming]="confirmingDeleteThreadId === thread.thread_id"
      [class.deleting]="deletingThreadId === thread.thread_id"
      (click)="onThreadRowClick(thread)"
      (keydown.enter)="onThreadRowKeydown($event, thread)"
      (mouseenter)="onThreadRowHover(thread)"
      (mouseleave)="onThreadRowHoverEnd()"
      (mousedown)="onThreadRowPress(thread, $event)"
      (focus)="onThreadRowHover(thread)">

      <!-- Renombrado inline: el lápiz convierte la fila en un input. Sin
           modal → nada puede quedar por debajo de la máscara del p-dialog. -->
      <ng-container *ngIf="editingThreadId === thread.thread_id; else threadRow">
        <input #threadRenameInput
          type="text"
          class="thread-rename-input"
          [(ngModel)]="newThreadTitle"
          [disabled]="isSavingThreadTitle"
          [placeholder]="'agent.newTitlePlaceholder' | translate"
          [attr.aria-label]="'agent.editConversationTitle' | translate"
          (click)="$event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); saveThreadTitle(thread)"
          (keydown.escape)="$event.stopPropagation(); cancelEditingThreadTitle()"
          (blur)="onRenameBlur(thread)" />
        <div class="thread-inline-actions">
          <!-- mousedown.preventDefault: que el clic no dispare antes el blur del input -->
          <button pButton type="button" class="row-icon-btn save-title-btn"
            [disabled]="isSavingThreadTitle || !newThreadTitle.trim()"
            (mousedown)="$event.preventDefault()"
            (click)="$event.stopPropagation(); saveThreadTitle(thread)"
            [title]="'common.save' | translate"
            [attr.aria-label]="'common.save' | translate">
            <i class="pi" [ngClass]="isSavingThreadTitle ? 'pi-spinner pi-spin' : 'pi-check'"></i>
          </button>
          <button pButton type="button" class="row-icon-btn"
            [disabled]="isSavingThreadTitle"
            (mousedown)="$event.preventDefault()"
            (click)="$event.stopPropagation(); cancelEditingThreadTitle()"
            [title]="'common.cancel' | translate"
            [attr.aria-label]="'common.cancel' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </ng-container>

      <ng-template #threadRow>
        <div class="thread-content">
          <div class="thread-title">
            <!-- Icono por TIPO (app#690): en «Todo» conviven chats y reglas -->
            <i class="pi thread-type-icon"
               [ngClass]="isRuleThread(thread) ? 'pi-shield thread-type-icon--rule' : 'pi-comment'"></i>
            <i *ngIf="isStreamingThread(thread)" class="pi pi-spinner pi-spin thread-streaming-icon"></i>
            <i *ngIf="!isStreamingThread(thread) && isAwaitingDecisionThread(thread)"
               class="pi pi-pause-circle thread-awaiting-icon"></i>
            <span class="thread-title-text">{{ getThreadDisplayTitle(thread) }}</span>
          </div>
          <span class="thread-date thread-streaming-label" *ngIf="isStreamingThread(thread)">{{ 'agent.threadRunning' | translate }}</span>
          <span class="thread-date thread-awaiting-label"
                *ngIf="!isStreamingThread(thread) && isAwaitingDecisionThread(thread)">{{ 'agent.threadAwaitingDecision' | translate }}</span>
          <span class="thread-date"
                [title]="getThreadDateTitle(thread)"
                *ngIf="!isStreamingThread(thread) && !isAwaitingDecisionThread(thread)">{{ getThreadDate(thread) }}</span>
        </div>

        <!-- Confirmación de borrado inline (sustituye al confirm() nativo) -->
        <div class="thread-delete-confirm"
          *ngIf="confirmingDeleteThreadId === thread.thread_id"
          (click)="$event.stopPropagation()"
          (keydown.escape)="$event.stopPropagation(); cancelDeleteThread()">
          <button pButton type="button" class="confirm-delete-btn"
            [disabled]="deletingThreadId === thread.thread_id"
            (click)="confirmDeleteThread(thread.thread_id, $event)">
            <i class="pi" [ngClass]="deletingThreadId === thread.thread_id ? 'pi-spinner pi-spin' : 'pi-trash'"></i>
            {{ 'common.delete' | translate }}
          </button>
          <button pButton type="button" class="cancel-delete-btn"
            [disabled]="deletingThreadId === thread.thread_id"
            (click)="cancelDeleteThread($event)">
            {{ 'common.cancel' | translate }}
          </button>
        </div>

        <!-- Acciones: visibles al pasar el ratón (o con foco de teclado).
             Renombrar solo chats: el título de una ejecución de regla viene de
             su regla. Eliminar, ambos (con confirmación inline). -->
        <div class="thread-actions"
          *ngIf="confirmingDeleteThreadId !== thread.thread_id && !isStreamingThread(thread)">
          <!-- Exportar conversación (SYN-930): menú de formatos en un popover; el
               progreso y el resultado van a la bandeja global. -->
          <sg-exportar-conversacion [threadId]="thread.thread_id" [titulo]="getThreadDisplayTitle(thread)"></sg-exportar-conversacion>
          <button pButton type="button" class="edit-btn"
            *ngIf="!isRuleThread(thread)"
            (click)="startEditingThreadTitle(thread, $event)"
            [title]="'agent.editTitle' | translate"
            [attr.aria-label]="'agent.editTitle' | translate">
            <i class="pi pi-pencil"></i>
          </button>
          <button pButton type="button" class="delete-btn"
            (click)="requestDeleteThread(thread, $event)"
            [title]="'agent.deleteConversation' | translate"
            [attr.aria-label]="'agent.deleteConversation' | translate">
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </ng-template>
    </div>

    <!-- Estados vacío/carga: FUERA del *ngFor -->
    <div *ngIf="isLoadingThreads && filteredThreads().length === 0" class="loading-threads">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'agent.loadingConversations' | translate }}</span>
    </div>

    <div *ngIf="!isLoadingThreads && filteredThreads().length === 0 && threadSearchQuery().trim()" class="no-threads">
      <i class="pi pi-search no-threads-icon"></i>
      <p>{{ 'agent.noSearchResults' | translate }}</p>
    </div>

    <div *ngIf="!isLoadingThreads && filteredThreads().length === 0 && !threadSearchQuery().trim()" class="no-threads">
      <i class="pi pi-comments no-threads-icon"></i>
      <p>{{ 'agent.noThreads' | translate }}</p>
    </div>
  </div>

</div>
